export const changeFormatOfDate = (date: string) => {
  const arrayOfDate = date.split('-')
  return `${arrayOfDate[2]}.${arrayOfDate[1]}.${arrayOfDate[0]}`
}
